import React, { Component } from 'react';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { ColorButton, DeleteModal, EmptyStateContainer, AddPropertyModal, SwitchContainer, PageHeader } from '../../../../neoverv';

// import de from
import DatePicker, { registerLocale } from 'react-datepicker';
import de from 'date-fns/locale/de';
import Autoload from '../../../../neoverv/Autoload';
import { isStarterTier, isPremiumTier } from '../../../../helpers/subscriptionFeatureAccess';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  updatePropetyInfo,
  editProfileData,
  deleteProperty,
  setPropertyList,
  changeCurrentProperty,
} from '../../../../redux/action/General/generalActions';
import { hideNotification, showNotification } from '@mantine/notifications';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import { Box, Grid, Group, Overlay, SimpleGrid, Skeleton, Stack, TextInput } from '@mantine/core';
import AddPropertyTypeModal from '../../../../neoverv/components/Module/General/CustomModal/AddPropertyTypeModal.jsx';
import PropertyDataHandler from '../../../../neoverv/helpers/DataHandler/Property';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
registerLocale('de', de);
class GeneralInformation extends Component {
  state = {
    isMobile: false,
    skeletonLoading: false,
    file: null,
    selectedPropertyType: null,
    propertyOwner: {
      name: null,
      street: null,
      postalCode: null,
      city: null,
      phoneNumber: null,
      email: null,
      taxNumber: null
    },
    isPropertyOwnerInfoEnabled: false,
    isPropertyOwnerInfoInMessagesEnabled: false,
    postPropertyOwnerDone: false,
    propertyData: null
  };

  componentDidMount() {
    this.setState({skeletonLoading: true});
    if(this.props.propertyData && this.props.propertyData.id !== undefined){
      this._fetchGeneralInfoData();
    }else{
      this.ShowLoader();
    }
  }

  toggleAddPropertyModal = () => {
    this.setState({ addPropertyModal: !this.state.addPropertyModal });
  };
  toggleAddPropertyTypeModal = () => {
    this.setState({ addPropertyTypeModal: !this.state.addPropertyTypeModal });
  };

  _getPropertyPicture() {
    const propertyID = this.props.propertyData.id;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyID + '/picture',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_getPropertyPictureResponse',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  _getPropertyPictureResponse(response) {
    if (response.status == true && response.statuscode == 200) {
      this.setState({ file: response.result });
    }
  }

  _fetchGeneralInfoData() {
    const propertyID = this.props.propertyData.id;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyID,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_property_data',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_get_property_data(response) {
    const {propertyOwner, isPropertyOwnerInfoEnabled, isPropertyOwnerInfoInMessagesEnabled} = this.props.propertySelected;
    const {changeCurrentProperty, propertySelected} = this.props;
    if (response.status == true && response.statuscode == 200) {
      if(response.result){
        let property = PropertyDataHandler.getProperty(response.result);
        this.setState({
          propertyData: property,
          propertyOwner: response.result?.propertyOwner,
          // propertyOwner: {
          //   name: propertySelected?.propertyOwner?.name,
          //   street: propertySelected?.propertyOwner?.street,
          //   postalCode: propertySelected?.propertyOwner?.postalCode,
          //   city: propertySelected?.propertyOwner?.city,
          //   phoneNumber: propertySelected?.propertyOwner?.phoneNumber,
          //   email: propertySelected?.propertyOwner?.email,
          //   taxNumber: propertySelected?.propertyOwner?.taxNumber
          // },//propertySelected?.propertyOwner ? propertySelected?.propertyOwner : this.state.propertyOwner,//response.result?.propertyOwner ? response.result?.propertyOwner : this.state.propertyOwner,
          isPropertyOwnerInfoEnabled: response.result?.isPropertyOwnerInfoEnabled,
          isPropertyOwnerInfoInMessagesEnabled: response.result?.isPropertyOwnerInfoInMessagesEnabled
        });
      }
      // this.setState({
      //   // propertyOwner: {
      //   //   name: '',
      //   //   street: '',
      //   //   postalCode: '',
      //   //   city: '',
      //   //   phoneNumber: '',
      //   //   email: '',
      //   //   taxNumber: ''
      //   // },
      //   // isPropertyOwnerInfoEnabled: false,
      //   // isPropertyOwnerInfoInMessagesEnabled: false
        
      //   propertyOwner: {
      //     name: propertySelected?.propertyOwner?.name,
      //     street: propertySelected?.propertyOwner?.street,
      //     postalCode: propertySelected?.propertyOwner?.postalCode,
      //     city: propertySelected?.propertyOwner?.city,
      //     phoneNumber: propertySelected?.propertyOwner?.phoneNumber,
      //     email: propertySelected?.propertyOwner?.email,
      //     taxNumber: propertySelected?.propertyOwner?.taxNumber
      //   },//propertySelected?.propertyOwner ? propertySelected?.propertyOwner : this.state.propertyOwner,//response.result?.propertyOwner ? response.result?.propertyOwner : this.state.propertyOwner,
      //   isPropertyOwnerInfoEnabled: response.result?.isPropertyOwnerInfoEnabled,
      //   isPropertyOwnerInfoInMessagesEnabled: response.result?.isPropertyOwnerInfoInMessagesEnabled
      // });
    }
    this.ShowLoader();
  }

  _addGeneralInfo(callBackFunction=null) {
    hideNotification('save_property_data');
    hideNotification('save_property_data_error');
    const {propertySelected} = this.props;
    const {isPropertyOwnerInfoEnabled, isPropertyOwnerInfoInMessagesEnabled} = this.state;
    let heatingValue =
      this.state.heatingType === lang.property.generalinfo_warm_water
        ? 'central with warm water'
        : this.state.heatingType === lang.property.generalinfo_without_warm_water
          ? 'central without warm water'
          : this.state.heatingType === lang.property.generalinfo_decentralized
            ? 'decentralized'
            : '';

    const propertyID = this.props.propertyData.id;
    const accountID = this.props.profileData.accountId;
    this.setState({
      oldPropertyName: this.state.propertyName,
      oldPropertyAddress: this.state.propertyAddress,
      oldPropertyCity: this.state.propertyCity,
      oldPropertyZipCode: this.state.propertyZipCode,
      oldTotalRentingSpace: this.state.totalRentingSpace,
      oldNumberOfRentalUnits: this.state.numberOfRentalUnits,
      oldTotalOccupantsCount: this.state.totalOccupantsCount
    })
    const generalInfoData ={
      ...propertySelected,
      propertyId: propertyID,
      accountId: accountID,
      name: propertySelected.name,
      propertyAdress: {
        streetno: propertySelected.propertyAddress,
        city: propertySelected.propertyCity,
        zipCode: propertySelected.propertyZipCode,
      },
      totalRentingSpace: propertySelected.totalRentingSpace,
      numberOfRentalUnits: propertySelected.numberOfRentalUnits,
      cutOffDate: propertySelected.cutOffDate,
      heatingType: propertySelected.heatingType,
      heatingTemperature: propertySelected.heatingTemperature,
      consumptionShare: propertySelected.consumptionShare,
      energyFuelType: propertySelected.energyFuelType,
      receiptEmail: propertySelected.receiptEmail,
      meterReadingsEmail: propertySelected.meterReadingsEmail,
      centralWarmwaterAllocationKey: propertySelected.centralWarmwaterAllocationKey,
      isMeterReadingConducted: propertySelected.isMeterReadingConducted,
      propertyType: propertySelected.propertyType,
      occupantsConfiguration: propertySelected.occupantsConfiguration,
      pictureLocation: propertySelected.pictureLocation,
      isConsumptionSectionHidden: propertySelected.isConsumptionSectionHidden,
      isDocumentSectionHidden: propertySelected.isDocumentSectionHidden,
      isMessageSectionHidden: propertySelected.isMessageSectionHidden,
      isPropertyOwnerInfoEnabled,
      isPropertyOwnerInfoInMessagesEnabled
    }
    console.log('generalInfoData', generalInfoData);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyID,
      'PUT',
      generalInfoData,
      null,//btnelement.children[0],
      false,
      true,
      false,
      this,
      '_PutGeneralInfoResponse',
      { generalInfoData, callBackFunction },
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  _PutGeneralInfoResponse(response) {
    if(response.status && response.statuscode === 200){
      showNotification({
        id: 'save_property_data',
        icon: <img src={GreenTick} alt='green-tick'/>,
        message: 'Die Änderungen wurden übernommen.',
      });
      this.updateProperties(response.other.generalInfoData);
    }else{
      showNotification({
        id: 'save_property_data_error',
        icon: <img src={RedCross} alt='red-cross'/>,
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
      });
    }

    if(response.other.callBackFunction && this.state.propertyOwner === null && this.state.postPropertyOwnerDone === false){
      response.other.callBackFunction();
    }
  }

  updateProperties(updated_property_response, deleteProperty=false, callBackFunction=null) {
    const {isPropertyOwnerInfoEnabled, isPropertyOwnerInfoInMessagesEnabled, propertyOwner} = this.state;
    let {propertySelected} = this.props;
    propertySelected={
      ...propertySelected,
      ...updated_property_response,
      isPropertyOwnerInfoEnabled,
      isPropertyOwnerInfoInMessagesEnabled,
      propertyOwner
    }

    this.props.changeCurrentProperty(propertySelected);

    if(callBackFunction){
      callBackFunction();
    }
  }

  ShowLoader = () => {
    this.setState({skeletonLoading: false});
  };

  validateForm = () => {
      // console.log('validate form');
      this.setState({
        propertyNameErrMsg: false,
        numberOfRentalUnitsErrMsg: false,
        totalRentingSpaceErrMsg: false,
        // addressErrMsg: false,
        // areaOfUnitsErrMsg: false,
        // noOfUnitsErrMsg: false,
        // cityErrMsg: false,
        // zipCodeErrMsg: false,
        // fuelTypeErrMsg: false,
        // heatingTempErrMsg: false,
        // heatingTypeErrMsg: false,
        // selectedOptionErrMsg: false,
      });
      let propertyNameErrMsg, numberOfRentalUnitsErrMsg, totalRentingSpaceErrMsg = false;
        // addressErrMsg,
        // areaOfUnitsErrMsg,
        // cityErrMsg,
        // zipCodeErrMsg,
        // noOfUnitsErrMsg,
        // fuelTypeErrMsg,
        // heatingTempErrMsg,
        // heatingTypeErrMsg,
        // selectedOptionErrMsg = false;
      const validNum = /^[0-9]/;
      //const validName = /^[a-zA-Z]+(?:[\s]+[a-zA-Z]+)*$/;
      const validName = /[^a-zA-Z0-9äöüÄÖÜß]/;
      if (!this.state.propertyName) {
        propertyNameErrMsg = true;
      }

      if(this.props.propertySelected.propertyType !== 'REGULAR' && !this.state.numberOfRentalUnits){
        numberOfRentalUnitsErrMsg = true;
      }
  
      if(this.props.propertySelected.propertyType !== 'REGULAR' && !this.state.totalRentingSpace){
        totalRentingSpaceErrMsg = true;
      }
  
      // if(this.state.heatingType !== lang.property.generalinfo_decentralized && (!this.state.energyFuelType || !this.state.energyFuelType.fuelTypeName || this.state.energyFuelType.fuelTypeName === lang.newKeys.text_select)) {
      //   fuelTypeErrMsg = true;
      // }
      // if (!this.state.address) {
      //   addressErrMsg = true;
      // }
      // if (!this.state.city) {
      //   cityErrMsg = true;
      // }
      // if (!this.state.zipCode) {
      //   zipCodeErrMsg = true;
      // }
      // if (!this.state.areaOfUnits || !validNum.test(this.state.areaOfUnits)) {
      //   areaOfUnitsErrMsg = true;
      // }
      // if (
      //   !this.state.noOfUnits ||
      //   !validNum.test(this.state.noOfUnits) ||
      //   !validNum.test((this.state.noOfUnits + '').replace('m²', ''))
      // ) {
      //   noOfUnitsErrMsg = true;
      // }
  
      // if (
      //   !this.state.heatingTemp ||
      //   !validNum.test(this.state.heatingTemp) ||
      //   !validNum.test((this.state.heatingTemp + '').replace('°C', ''))
      // ) {
      //   heatingTempErrMsg = true;
      // }
      // if (
      //   !this.state.selectedOption ||
      //   !validNum.test(this.state.selectedOption) ||
      //   !validNum.test((this.state.selectedOption + '').replace('°%', ''))
      // ) {
      //   selectedOptionErrMsg = true;
      // }
  
      // if (!this.state.heatingTypeErrMsg || this.state.heatingTypeErrMsg === lang.newKeys.text_select) {
      //   heatingTypeErrMsg = true;
      // }
  
      this.setState({
        propertyNameErrMsg,
        totalRentingSpaceErrMsg,
        numberOfRentalUnitsErrMsg
        // addressErrMsg,
        // areaOfUnitsErrMsg,
        // noOfUnitsErrMsg,
        // cityErrMsg,
        // zipCodeErrMsg,
        // fuelTypeErrMsg,
        // heatingTypeErrMsg,
        // selectedOptionErrMsg,
        // heatingTempErrMsg,
      });
  
      if (!propertyNameErrMsg && !totalRentingSpaceErrMsg && !numberOfRentalUnitsErrMsg) {
        this._addGeneralInfo()
      } else {
        showNotification({
          message: 'Bitte ergänzen Sie die fehlenden Informationen.',
          icon: <img src={RedCross} alt='red-tick'/>,
        });
        this.setState({oldNumberOfRentalUnits: this.state.numberOfRentalUnits, oldTotalRentingSpace: this.state.totalRentingSpace});
      }
  }

  onInputChangeForPropertyOwnerObject=(value, field)=>{
    let {propertyOwner} = this.state;
    propertyOwner[field] = value?.length > 0 ? value : null;
    this.setState({propertyOwner});
  }

  postPropertyOwner=()=>{
    const {propertySelected} = this.props;
    let propertyOwner = {
      name: null,
      street: null,
      postalCode: null,
      city: null,
      phoneNumber: null,
      email: null,
      taxNumber: null
    };
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertySelected?.id + '/propertyOwner',
      'POST',
      propertyOwner,
      null,
      false,
      true,
      false,
      this,
      'handlePostPropertyOwner',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handlePostPropertyOwner(response){
    if(response.status && response.statuscode === 200){
      this.setState({postPropertyOwnerDone: true}, ()=> this._fetchGeneralInfoData());
    }else{
      this._fetchGeneralInfoData();
    }
  }

  putPropertyOwner=()=>{
    hideNotification('save_property_data');
    hideNotification('save_property_data_error');
    const {propertyOwner} = this.state;
    const {propertySelected} = this.props;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertySelected?.id + '/propertyOwner',
      'PUT',
      propertyOwner,
      null,
      false,
      true,
      false,
      this,
      'handlePutPropertyOwner',
      {propertyOwner},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handlePutPropertyOwner(response){
    if(response.status && response.statuscode === 200){
      showNotification({
        id: 'save_property_data',
        icon: <img src={GreenTick} alt='green-tick'/>,
        message: 'Die Änderungen wurden übernommen.',
      });
    }else{
      showNotification({
        id: 'save_property_data_error',
        icon: <img src={RedCross} alt='red-cross'/>,
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
      });
    }

    // if(!(response.other.propertyOwner?.name && response.other.propertyOwner?.street && response.other.propertyOwner?.city && response.other.propertyOwner?.postalCode && response.other.propertyOwner?.email)){
    //   let isPropertyOwnerInfoInMessagesEnabledOldState = this.state.isPropertyOwnerInfoInMessagesEnabled;
    //   this.setState({isPropertyOwnerInfoInMessagesEnabled: false}, ()=> this.updateProperties(null, false, ()=> isPropertyOwnerInfoInMessagesEnabledOldState && this._addGeneralInfo()));
    // }else{
    //   this.updateProperties(null, false, ()=> this._fetchGeneralInfoData())
    // }
    this.updateProperties(null, false, ()=> this._fetchGeneralInfoData())
  }

  render() {
    const {propertySelected, isMobile, currentSubscription, accountData} = this.props;
    const {selectedPropertyType, addPropertyTypeModal, addPropertyModal, propertyOwner, isPropertyOwnerInfoEnabled, isPropertyOwnerInfoInMessagesEnabled, skeletonLoading} = this.state;

    console.log('propertySelected_231234: ', propertySelected);
    //let disableDisplayPropertyOwnerInfoInMessages = (propertyOwner?.name && propertyOwner?.street && propertyOwner?.city && propertyOwner?.postalCode && propertyOwner?.email) ? false : true;
    const professionalOverlay = (isStarterTier(currentSubscription) || isPremiumTier(currentSubscription));
    return (
      <>
        <div id="empty-generalinfo-page"></div>
        <Box style={{ height: '100%', position: 'relative'}}>
          <div style={{ position: 'relative', maxWidth: isMobile ? 'auto' : '460px', marginTop: professionalOverlay && '40px'}}>
            {professionalOverlay &&
            <Stack align={'center'} style={{ zIndex: 50, position: 'absolute', left: 0, right: 0, marginRight: 'auto', marginLeft: 'auto', marginTop: '150px'}}>
              <Stack gap={0}>
                <span style={{color: '#0E0E1D', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Professionelle Hausverwaltung</span>
                <span style={{color: '#5555FF', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Mit hellohousing Professional.</span>
              </Stack>
              <Group>
                <div>
                  <ColorButton
                  text={'Jetzt freischalten'}
                  className='purple-btn'
                  onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})}
                  />
                </div>
              </Group>
              <Group style={{width: '460px'}}>
                <span style={{color: '#615C7E', fontSize: '12px', textAlign: 'center'}}>Hinterlegen Sie Informationen zum Eigentümer, um Objekte im Eigentümerauftrag mit hellohousing zu verwalten.</span>
              </Group>
              {/* <Group>
                <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px', cursor: 'pointer'}} onClick={()=> window.Intercom('showArticle', '6776182')}>Zählerdatenverarbeitung kennenlernen</span>
              </Group> */}
            </Stack>}
            {professionalOverlay &&
            <Overlay opacity={0.5} blur={4} zIndex={5} color={'#F7F7FA'}/>}
          <div className="propertyOwnerinfo-page" id="respond-propertyOwnerinfo-page" style={{ display: 'block' }}>
          <PageHeader
            heading={!isMobile && <Skeleton style={{marginTop: '7px'}} visible={skeletonLoading}>{'Eigentümer'}</Skeleton>}
            headingClassName={'tooltips property-property-owner-info-heading'}
            hideDivider={true}
            searchElement={
            <Group style={{marginTop: '19px'}}>
              <SwitchContainer
              switchText={'Eigentümerinformationen erfassen'}
              checked={isPropertyOwnerInfoEnabled}
              onChange={()=> this.setState({isPropertyOwnerInfoEnabled: !isPropertyOwnerInfoEnabled}, ()=> this._addGeneralInfo(()=> !isPropertyOwnerInfoEnabled ? this.postPropertyOwner() : null))}
              disabled={skeletonLoading}
              className={'enable-property-owner-information-switch'}
              textClassName={'tooltips enable-property-owner-information-switch-label'}
              />
            </Group>}
          />
          {isPropertyOwnerInfoEnabled &&
          <Grid style={{maxWidth: isMobile ? 'auto' : '383px'}}>
            <Grid.Col span={12}>
              <TextInput
              value={propertyOwner?.name}
              label={'Name / Firma'}
              required
              classNames={{
                label: 'property-owner-information-input-labels',
                input: 'property-owner-information-input',
              }}
              //disabled={!isPropertyOwnerInfoEnabled}
              onChange={(event) => this.onInputChangeForPropertyOwnerObject(event.currentTarget.value, 'name')}
              onBlur={()=> this.putPropertyOwner()}
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
              value={propertyOwner?.street}
              label={'Adresse'}
              required
              classNames={{
                label: 'property-owner-information-input-labels',
                input: 'property-owner-information-input',
              }}
              //disabled={!isPropertyOwnerInfoEnabled}
              onChange={(event) => this.onInputChangeForPropertyOwnerObject(event.currentTarget.value, 'street')}
              onBlur={()=> this.putPropertyOwner()}
              />
            </Grid.Col>
            <Grid.Col span={9}>
              <TextInput
              value={propertyOwner?.city}
              label={'Ort'}
              required
              classNames={{
                label: 'property-owner-information-input-labels',
                input: 'property-owner-information-input',
              }}
              //disabled={!isPropertyOwnerInfoEnabled}
              onChange={(event) => this.onInputChangeForPropertyOwnerObject(event.currentTarget.value, 'city')}
              onBlur={()=> this.putPropertyOwner()}
              />
            </Grid.Col>
            <Grid.Col span={3}>
              <TextInput
              value={propertyOwner?.postalCode}
              label={'PLZ'}
              required
              classNames={{
                label: 'property-owner-information-input-labels',
                input: 'property-owner-information-input',
              }}
              //disabled={!isPropertyOwnerInfoEnabled}
              onChange={(event) => this.onInputChangeForPropertyOwnerObject(event.currentTarget.value, 'postalCode')}
              onBlur={()=> this.putPropertyOwner()}
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
              value={propertyOwner?.email}
              label={'E-Mail'}
              required
              classNames={{
                label: 'property-owner-information-input-labels',
                input: 'property-owner-information-input',
              }}
              //disabled={!isPropertyOwnerInfoEnabled}
              onChange={(event) => this.onInputChangeForPropertyOwnerObject(event.currentTarget.value, 'email')}
              onBlur={()=> this.putPropertyOwner()}
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
              value={propertyOwner?.phoneNumber}
              label={'Telefon (optional)'}
              classNames={{
                label: 'property-owner-information-input-labels',
                input: 'property-owner-information-input',
              }}
              //disabled={!isPropertyOwnerInfoEnabled}
              onChange={(event) => this.onInputChangeForPropertyOwnerObject(event.currentTarget.value, 'phoneNumber')}
              onBlur={()=> this.putPropertyOwner()}
              />
            </Grid.Col>
            {/* <Grid.Col span={6}>
              <TextInput
              value={propertyOwner?.taxNumber}
              label={'Steuernummer (optional)'}
              classNames={{
                label: 'property-owner-information-input-labels',
                input: 'property-owner-information-input',
              }}
              //disabled={!isPropertyOwnerInfoEnabled}
              onChange={(event) => this.onInputChangeForPropertyOwnerObject(event.currentTarget.value, 'taxNumber')}
              onBlur={()=> this.putPropertyOwner()}
              />
            </Grid.Col> */}
            <Grid.Col span={12}>
              <Group>
                <SwitchContainer
                switchText={'Kontaktdaten auf Abrechnungen und Nachrichten verwenden'}
                checked={isPropertyOwnerInfoInMessagesEnabled}
                //checked={disableDisplayPropertyOwnerInfoInMessages ? false : isPropertyOwnerInfoInMessagesEnabled}
                onChange={()=> this.setState({isPropertyOwnerInfoInMessagesEnabled: !isPropertyOwnerInfoInMessagesEnabled}, ()=> this._addGeneralInfo())}
                disabled={skeletonLoading}
                //disabled={skeletonLoading || disableDisplayPropertyOwnerInfoInMessages}
                className={'enable-property-owner-information-in-messages-switch'}
                textClassName={'tooltips enable-property-owner-information-in-messages-switch-label'}
                />
              </Group>
            </Grid.Col>
          </Grid>}
          </div>
          </div>
        {addPropertyModal &&
        <AddPropertyModal
          className="add_proprty_modal"
          edit={false}
          open={addPropertyModal}
          toggle={() => {
            this.toggleAddPropertyModal();
          }}
          propertyType={selectedPropertyType}
        />}
        {addPropertyTypeModal &&
        <AddPropertyTypeModal
          className="add_proprty_type_modal"
          open={addPropertyTypeModal}
          toggle={() => {
            this.toggleAddPropertyTypeModal();
          }}
          next={(selectedPropertyType)=> {
            this.setState({selectedPropertyType});
            this.toggleAddPropertyTypeModal();
            this.toggleAddPropertyModal();
          }}
          history={this.props.history}
        />}
        </Box>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertyData: state.generalReducer.property,
    profileData: state.generalReducer.profile,
    allProperties: state.generalReducer.allProperties,
    propertySelected: state.generalReducer.property,
    accountData: state.generalReducer.accountData,
    currentSubscription: state.generalReducer.currentSubscription,
  };
};

const actions = {
  updatePropetyInfo,
  deleteProperty,
  editProfileData,
  setPropertyList,
  changeCurrentProperty,
  updatePropetyInfo,
};

export default connect(mapStateToProps, actions)(GeneralInformation);
